import { View } from 'react-native';
import { useTheme } from '@/theme';
import { TripSearchBar } from './TripSearchBar';
import { TripFilterBar, TripFilterType } from './TripFilterBar';

type CombinedSearchFilterBarProps = {
  searchValue: string;
  onChangeSearch: (text: string) => void;
  selectedFilter: TripFilterType;
  onFilterChange: (filter: TripFilterType) => void;
  tone?: 'default' | 'inverse';
  upcomingCount?: number;
  completedCount?: number;
  archivedCount?: number;
};

export function CombinedSearchFilterBar({
  searchValue,
  onChangeSearch,
  selectedFilter,
  onFilterChange,
  tone = 'default',
  upcomingCount,
  completedCount,
  archivedCount,
}: CombinedSearchFilterBarProps) {
  const theme = useTheme();

  return (
    <View style={{ gap: theme.spacing(1) }}>
      <TripSearchBar
        value={searchValue}
        onChangeText={onChangeSearch}
        placeholder="Search trips..."
        historyShortcutVisible={false}
        tone={tone}
      />
      <TripFilterBar
        selectedFilter={selectedFilter}
        onFilterChange={onFilterChange}
        tone={tone}
        upcomingCount={upcomingCount}
        completedCount={completedCount}
        archivedCount={archivedCount}
      />
    </View>
  );
}


